import dayjs from "dayjs"
import { useTranslation } from "react-i18next"
import { Link, useRouteMatch } from "react-router-dom"
import { useCommonDataContext } from "../../hooks/CommonDataContext"
import { usePlanContext } from "../../hooks/PlanContext"

const TaskPreview = ({ task }) => {
  const { url } = useRouteMatch()
  const { t } = useTranslation()
  const { specialities, workplaces } = useCommonDataContext()
  const { plans } = usePlanContext()

  return (
    <div className="box">
      <div className="columns mb-0 pb-0">
        <div className="column is-half">
          <Link to={url + "/view/" + task.id}>
            {plans.find(pl => pl.id === task.planID)?.title}
          </Link>
        </div>

        <div className="column is-half has-text-right has-text-grey">
          {task.id}
        </div>
      </div>

      <hr className="mt-0" />

      <div className="columns">
        <div className="column is-half">
          <p>
            <strong>{t("need.speciality")}: </strong>
            {specialities.find(spec => spec.id === task.specialityID)?.title}
          </p>

          <p>
            <strong>{t("need.workplace")}: </strong>
            {workplaces.find(wp => wp.id === task.workplaceID)?.title}
          </p>
        </div>

        <div className="column is-half">
          <p>
            <strong>{t("plan.creationDate")}: </strong>
            {dayjs(task?.creationDate).format("DD/MM/YYYY HH:mm")}
          </p>

          <p>
            <strong>{t("plan.lastUpdateDate")}: </strong>
            {dayjs(task?.lastUpdateDate).format("DD/MM/YYYY HH:mm")}
          </p>
        </div>
      </div>
    </div>
  )
}

export default TaskPreview
